import { Timeouts } from '../framework/Timeouts';
const debugDynamic = false;
export class BlustreamAcm200 {
    constructor(socket, log) {
        this.socket = socket;
        this.log = log;
        this.timeouts = new Timeouts();
        this.changeOutputsInterval = this.timeouts.createInterval();
        this.changeOutputsToggle = true;
        this.product = {
            modelNumber: '-MWimGDufNtk_hKg6Ykp',
            name: 'IP Control Box ACM200 Status Info',
            version: '1.38',
            numberInputs: 4,
            numberOutputs: 10,
        };
        this.videoOutputs = Array(16).fill('001');
        this.asyncHandlers = [
            {
                name: 'matrixRoute',
                regExp: /OUT(\d+)FR(.+)/i,
                callback: (match) => {
                    const outputIndex = parseInt(match[1], 10) - 1;
                    this.videoOutputs[outputIndex] = match[2];
                    this.socket.send(`[SUCCESS]Set output ${match[1]} from input ${match[2]}`);
                },
            },
            {
                name: 'status',
                regExp: /STATUS/i,
                callback: (match) => {
                    const statusMessage = this.acm200CreateStatusMessage();
                    statusMessage.forEach(element => this.socket.send(element));
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`[ERROR]Command not found.`);
                },
            },
        ];
    }
    onConfigure(config) {
        this.timeouts.clearAll();
        if (debugDynamic) {
            this.product.numberOutputs = 10;
            this.changeOutputsToggle = true;
            this.changeOutputsInterval.set(this.onChangeOutputs.bind(this), 30000);
        }
    }
    onDisconnect() {
        this.timeouts.clearAll();
    }
    acm200CreateStatusMessage() {
        let outString = [];
        outString.push('================================================================');
        outString.push(`               ${this.product.name}`);
        outString.push(`               FW Version: ${this.product.version}`);
        outString.push(`In   EDID  IP               NET/Sig`);
        for (let i = 1; i <= this.product.numberInputs; i++) {
            const inName = i.toString().padStart(3, '0');
            outString.push(`${inName}  DF015  169.254.003.${inName}`);
        }
        outString.push('\r\nOut   FromIn  IP              NET/HDMI');
        for (let i = 1; i <= this.product.numberOutputs; i++) {
            const outName = i.toString().padStart(3, '0');
            outString.push(`${outName}  ${this.videoOutputs[i - 1]} 169.254.006.${outName}`);
        }
        outString.push('LAN     DHCP    IP              Gateway         SubnetMask');
        outString.push('01_POE  Off     169.254.002.225 169.254.002.001 255.255.000.000');
        outString.push('02_CTRL Off     192.168.000.225 192.168.000.001 255.255.000.000');
        outString.push('Telnet  LAN01 MAC               LAN02 MAC');
        outString.push('0023    34:D0:B8:20:17:B1       34:D0:B8:20:17:B2');
        outString.push('================================================================');
        return outString;
    }
    onChangeOutputs() {
        if (this.changeOutputsToggle) {
            this.log.debug(`adding video output`);
            this.product.numberOutputs++;
        }
        else {
            this.log.debug(`removing video output`);
            this.product.numberOutputs--;
        }
        this.changeOutputsToggle = !this.changeOutputsToggle;
    }
}
BlustreamAcm200.emulatorType = 'socketEmulator';
BlustreamAcm200.key = '-MWimPYqWGj6a8v-3Nuu';
